import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarDays, Link2 } from "lucide-react";
import { api } from "@/lib/api";
import { useLiveRefresh } from "@/lib/live";
import { CAT_RGB, parseYmd, whenLabel } from "@/lib/calendar";

export default function ComingUpCard({ hub }) {
  const [ev, setEv] = useState(null);
  const load = useCallback(() => api.get(`/organizations/${hub.id}/calendar/upcoming`).then(({ data }) => { window.__hubTz = data.timezone; setEv(data.events); }).catch(() => setEv([])), [hub.id]);
  useEffect(() => { load(); }, [load]);
  useLiveRefresh(load, (m) => m.organization_id === hub.id && m.entity === "calendar.event", null);
  if (ev === null) return <div className="q-card h-[188px] animate-pulse" />;
  return (
    <section className="q-card q-rise" data-testid="home-coming-up-card">
      <div className="mb-3 flex items-center justify-between">
        <h2 className="flex items-center gap-2 font-display text-lg font-bold text-q-text"><CalendarDays className="h-4 w-4" style={{ color: "rgb(var(--glow-calendar))" }} /> Coming up</h2>
        <Link to={`/h/${hub.id}/calendar/family`} className="inline-flex min-h-[44px] items-center text-xs font-semibold text-q-muted hover:text-q-text" data-testid="home-coming-up-calendar-link">Calendar</Link>
      </div>
      {ev.length === 0 ? <p className="text-sm text-q-muted" data-testid="home-coming-up-empty">Nothing on the calendar yet.</p> : (
        <ul className="space-y-2">
          {ev.map((e, i) => (
            <li key={e.id} className="flex items-center gap-3" data-testid={`home-coming-up-${i}`}>
              <span className="flex h-11 w-11 flex-shrink-0 flex-col items-center justify-center rounded-xl text-[10px] font-black uppercase leading-tight" style={{ background: `rgba(${CAT_RGB[e.category]},0.15)`, color: `rgb(${CAT_RGB[e.category]})` }}>
                {(e.all_day ? parseYmd(e.start) : new Date(e.start)).toLocaleDateString([], { month: "short" })}
                <span className="font-display text-base">{(e.all_day ? parseYmd(e.start) : new Date(e.start)).getDate()}</span>
              </span>
              <div className="min-w-0">
                <p className="flex items-center gap-1 truncate font-semibold text-q-text">{e.source === "link" && <Link2 className="h-3.5 w-3.5 text-q-faint" />}{e.title}</p>
                <p className="text-xs text-q-faint">{whenLabel(e)}</p>
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
